import { useMutation } from '@tanstack/react-query';
import Api, { withAcl } from 'hooks/Api';
import { useLocation } from 'react-router-dom';
import { useAdminParams } from 'utils/helpers';
import { useProvider } from 'utils/providers/Provider';
import { TOKEN_SCOPE_TYPE } from 'utils/types';

interface Payload {
  returnUrl: string;
  scope: TOKEN_SCOPE_TYPE;
}

export default function useGoogleRegister() {
  const { state } = useProvider();
  const { accountId, accountUserId } = useAdminParams();
  const location = useLocation();
  const version = location.pathname.includes('onboarding') ? 'v3' : 'v1';
  const args = state;

  return useMutation({
    mutationFn: async (payload: Payload) => {
      const api = new Api(args);

      const data = await api.post(
        await withAcl({
          account: {
            url: `api/${version}/channels/google/register`,
            payload,
          },
          admin: {
            url: `api/v2/accounts/${accountId}/users/${accountUserId}/channels/google/register`,
            payload,
          },
        }),
      );

      return data;
    },
  });
}
